// extracted by mini-css-extract-plugin
export default {"subheader":"SubHeaderH2_subheader__zabyK"};